import { useEffect } from 'react'
import PropTypes from 'prop-types'

const useNoScrollHidden = (condition) => {
  useEffect(() => {
    if (condition) {
      document.querySelector('body').classList.add('no-scroll-hidden')
      document.getElementById('content').classList.add('no-scroll-hidden')
    }
    return () => {
      document.querySelector('body').classList.remove('no-scroll-hidden')
      document.getElementById('content').classList.remove('no-scroll-hidden')
    }
  }, [condition])
}

useNoScrollHidden.propTypes = {
  condition: PropTypes.bool,
}

useNoScrollHidden.defaultProps = {
  condition: true,
}

export default useNoScrollHidden
